export default {
  table: state => tableName => state[tableName],
};



// WEBPACK FOOTER //
// ./src/hardware/VuexTable/getters.js